import React from 'react';
import PropTypes from 'prop-types';
import { Multiline } from '@knockrentals/knock-shared-web-v2';
import { TabSection } from '../TabSections';
import { SECTIONS } from '../constants';
import {
  DETAILS,
  FIELD_LABELS,
  MAX_DETAILS_LENGTH,
  PLACEHOLDERS,
} from './constants';
import { makeCss } from '../../../../../../knock-design-system';

const { DESCRIPTION, TITLE } = SECTIONS.AFFORDABLE_OVERVIEW;

const useCss = makeCss({
  counter: {
    '& .MuiFormHelperText-root:not(.Mui-error)': {
      textAlign: 'right',
    },
  },
});

const AffordableOverview = ({
  clearFieldErrorMessage,
  details = '',
  updateAffordable,
  validationErrorMessages = {},
}) => {
  const css = useCss();
  const validationErrorMessage = validationErrorMessages[DETAILS];
  const counterText = `${details.length}/${MAX_DETAILS_LENGTH}`;

  const handleOnBlur = (e) => {
    const { name, value } = e.target;
    updateAffordable({ [name]: value.trim() });
  };

  const handleOnChange = (value, e) => {
    const { name } = e.target;
    updateAffordable({ [name]: value });
  };

  const handleOnFocus = () => {
    if (validationErrorMessage) {
      clearFieldErrorMessage(DETAILS);
    }
  };

  return (
    <TabSection description={DESCRIPTION} title={TITLE}>
      <div css={css.counter}>
        <Multiline
          error={Boolean(validationErrorMessage)}
          fullWidth
          helperText={validationErrorMessage || counterText}
          id={DETAILS}
          label={FIELD_LABELS[DETAILS]}
          maxLength={MAX_DETAILS_LENGTH}
          name={DETAILS}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          onFocus={handleOnFocus}
          placeholder={PLACEHOLDERS[DETAILS]}
          value={details}
          variant="outlined"
        />
      </div>
    </TabSection>
  );
};

AffordableOverview.propTypes = {
  clearFieldErrorMessage: PropTypes.func,
  details: PropTypes.string,
  updateAffordable: PropTypes.func,
  validationErrorMessages: PropTypes.object,
};

export default AffordableOverview;
